jQuery(function ($) {

    $(window).load(function() {
        $("html").removeClass("no-js"); // removes no-js class when js executes
        $("body").removeClass("preload"); // prevents flash of un-transitioned elements with css transitions
        $("#wrapper").removeClass("load-with-js"); // prevents flash of unstyled content and provides a fade on load effect with css

		/*****STICKY FOOTER****
        var footer = $("#footer");
        var pos = footer.position();
        var height = $(window).height();
        height = height - pos.top;
        height = height - footer.outerHeight();
        if (height > 0) {
            footer.css({
                'margin-top': height + 'px'
            });
        }*/

    });

	$(document).ready(function() {
		/*****REMOVE PARENT P TAG FROM CTA CLASS*****/
		var cta = $(".cta");
		if ( cta.parent().is( "p" ) ) {
			cta.unwrap();
		}

		equalHeight();

	});

    /***** EQUAL HEIGHT ELEMENTS *****/
    //add .equalheight class to items needing to be the same height
    function equalHeight() {
        var highest = 0;
        var hi = 0;
        $(".equalheight").css('height', '').each(function(){
        var h = $(this).outerHeight();
        if(h > hi){
           hi = h;
           highest = $(this).outerHeight();
        }
        });
        $('#output').html(highest);
        window.screenWidth = jQuery(window).width();
        if (window.screenWidth >= 740){
            $(".equalheight").css('height', highest);
        } else {
            $(".equalheight").css('height', 'initial');
        }
    }

    /***** MAKE PAGE HEADER & FOOTER HAVE A MIN-HEIGHT of the CONTENT HEIGHT WITHIN *****/
    function adaptPageElementsOnResizeAndReady() {

		var windowwidth = $( window ).width();

		// Page Header Min-Height
		var page_header = $("#page_header .row");
        var page_header_text = $("#header_text");
        var page_header_content_height = parseInt(page_header_text.innerHeight());
        var page_header_content_top = 0;
		if (windowwidth >= 740 && document.getElementById(page_header)) {
            var row_padding_top = parseInt(page_header.css("padding-top"));
            var row_padding_bottom = parseInt(page_header.css("padding-bottom"));
			var page_header_content_position = $("#header_text").position();
            page_header_content_top = page_header_content_position.top;
            var page_header_content_margintop = parseInt($("#header_text").css("margin-top"));
            page_header_content_top = page_header_content_margintop+page_header_content_top+row_padding_top+row_padding_bottom;
        }
		if(page_header_content_top > "0") {
			page_header_min_height = page_header_content_top + page_header_content_height + 'px';
		}
        else {
			page_header_min_height = page_header_content_height + 'px';
		}
		page_header.css("min-height", page_header_min_height);

		// Page Footer Min-Height
		var page_footer = $("#page_footer .row");
        var page_footer_text = $("#footer_text");
        var page_footer_content_height = parseInt(page_footer_text.innerHeight());
        var page_footer_content_top = 0;
        if (windowwidth >= 740) {
            var frow_padding_top = parseInt(page_footer.css("padding-top"));
            var frow_padding_bottom = parseInt(page_footer.css("padding-bottom"));
			var page_footer_content_position = $("#footer_text").position();
            page_footer_content_top = page_footer_content_position.top;
            var page_footer_content_margintop = parseInt($("#footer_text").css("margin-top"));
            page_footer_content_top = page_footer_content_margintop+page_footer_content_top+frow_padding_top+frow_padding_bottom;
        }
		if(page_footer_content_top > "0") { page_footer_min_height = page_footer_content_top + page_footer_content_height + 'px'; }
        else { page_footer_min_height = page_footer_content_height + 'px'; }
        page_footer.css("min-height", page_footer_min_height);
        $("#page_footer").css("min-height", page_footer_min_height);

        // Make elements equal height on resize
        equalHeight();

	}
	$(document).on("ready", adaptPageElementsOnResizeAndReady);
	$(window).on("resize", adaptPageElementsOnResizeAndReady);

    /***** STATIC HEADER ON SCROLL *****/
    if ($("#scrollheader").length) {
        var $env_header_ht = $("#header").css("height");
        $env_header_ht = parseInt($env_header_ht);
        $(window).scroll(function() {
            var $envfromtop = $(this).scrollTop();
            if ($envfromtop > 0) {
                $("#scrollheader").css("display", "block");
            }
            else { $("#scrollheader").css("display", "none"); }
            if ($envfromtop >= $env_header_ht) {
                $("#scrollheader").addClass("scrolled");
            }
            else { $("#scrollheader").removeClass("scrolled"); }
        });
    }

	$('a.scrollto').click(function() {
        if (location.pathname.replace(/^\//,'') === this.pathname.replace(/^\//,'') && location.hostname === this.hostname && !$(this).parent().hasClass('is-accordion-submenu-parent')) {
          var target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
          if (target.length) {
            $('html, body').animate({
              scrollTop: target.offset().top
            }, 1000);
            return false;
          }
        }
    });

    /***** Switch Foundation class to allow the float right nav to use opens-right class for submenu alignment *****/
    $(".top-bar-right .menu li").each(function(){
        if ($(this).hasClass('opens-left')) {
            $(this).removeClass('opens-left');
            $(this).addClass('opens-right');
        }
    });

    /***** FADE IN ON SCROLL with CLASS *****/
    $(".fadein").css("opacity", 0);
    $(window).scroll(function() {
        var windowBottom = $(this).scrollTop() + $(this).innerHeight();
        $(".fadein").each(function() {
          /* Check the location of each desired element */
          var objectBottom = $(this).offset().top + $(this).outerHeight();
          /* If the element is completely within bounds of the window, fade it in */
          if (objectBottom < windowBottom) { //object comes into view (scrolling down)
            if ($(this).css("opacity")==="0") { $(this).fadeTo(500,1); }
          } else { //object goes out of view (scrolling up)
            if ($(this).css("opacity")==="1") { $(this).fadeTo(500,0); }
          }
        });
    }).scroll(); //invoke scroll-handler on page-load

    /***** RESPONSIVE TABLES *****/
    // based on https://sitesforprofit.com/responsive-tables-in-wordpress
    (function () {
        var headertext = [];
        var headers = document.querySelectorAll("thead");
        var tablebody = document.querySelectorAll("tbody");

        for(var i = 0; i < headers.length; i++) {
            headertext[i]=[];
            for (var j = 0, headrow; headrow = headers[i].rows[0].cells[j]; j++) {
              var current = headrow;
              headertext[i].push(current.textContent.replace(/\r?\n|\r/,""));
              }
        }

        if (headers.length > 0) {
            for (var h = 0, tbody; tbody = tablebody[h]; h++) {
                for (var i = 0, row; row = tbody.rows[i]; i++) {
                  for (var j = 0, col; col = row.cells[j]; j++) {
                    col.setAttribute("data-th", headertext[h][j]);
                  }
                }
            }
        }
    } ());

    /***** HAVE CLASS? *****/
    function hasClass(element, cls) {
        return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
    }

    /***** GO TO CATEGORY ARCHIVE BASED ON SELECT *****/
    // Add this back if you need to return to a filtered category page from a single page
    // eg: single-resources or single-staff
    /*
    var siteurl = ENV_VARS.siteurl;
	var postpage = ENV_VARS.postpage;
	var resourcepage = ENV_VARS.resourcepage;
	var staffpage = ENV_VARS.staffpage;
    var dropdown = document.getElementById("cat_select");
    var cat_slug = 'category';
	var page_slug = "?p="+postpage;
    if (dropdown) {
        if (hasClass(dropdown, 'staff_cat')) { cat_slug = "staff-category"; page_slug = "?p="+staffpage; }
		console.log(page_slug);
        var onCatChange = function () {
            if ( dropdown.options[dropdown.selectedIndex].value ) {
				if ( dropdown.options[dropdown.selectedIndex].value === "all" ) {
					location.href = siteurl+"/"+page_slug;
				}
                else { location.href = siteurl+"/"+cat_slug+"/"+dropdown.options[dropdown.selectedIndex].value; }
            }
        };
        dropdown.onchange = onCatChange;
    }
    */

});